import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { ITeeDeck } from "redux/reducers/models/facility";

const apiVersion = "2024-04";
const adminType = "facility-admin";
const baseUrl = "/" + apiVersion + "/" + adminType + "/facility/tee-deck";

export type TGetTeeDeck = {
  id?: string | number;
  course_id?: string | number;
};

interface IPostYardages {
  division_id: number;
  tee_deck_id: number;
}
export interface ITeeDeckRating {
  course_rating: number;
  created_at: string;
  deleted_at: string;
  division_id: number;
  gender: string;
  id: number;
  slope_rating: number;
  tee_deck_id: number;
  updated_at: string;
}

// export type TPostTeeDeck = {};

// export type TPutTeeDeck = {};

// GET TeeDeck
export async function GetTeeDecks(params: TGetTeeDeck, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<ITeeDeck[]>(
    APIUrl(AdminType.FacilityAdmin, "/facility/tee-deck"),
    params,
    useGlobalLoader,
    token,
  );
}

// POST TeeDeck
export async function PostTeeDeck(params: any, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/facility/tee-deck"), params, useGlobalLoader);
}

// PUT TeeDeck
export async function PutTeeDeck(params: any, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/tee-deck"), params, useGlobalLoader);
}

export async function DeleteTeeDeck(params: any, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/facility/tee-deck"), params, useGlobalLoader);
}
// GET Yardages
export async function GetYardages(params: any, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/facility/tee-deck/yardages"), params, useGlobalLoader);
}

// PUT Yardages
export async function PutYardages(params: any, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/tee-deck/yardages"), params, useGlobalLoader);
}

// POST Yardages
export async function PostYardages(params: IPostYardages, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/facility/tee-deck/yardages"), params, useGlobalLoader);
}
